
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/aluminiumfalgar",
      function () {
        return require("private-next-pages/rims/aluminiumfalgar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/aluminiumfalgar"])
      });
    }
  